import { PathsOf } from '@/types/subform';

export interface RegenerateSummaryModalFormShape {
  summaryPromptId: string;
  incorporateAllDocuments: boolean;
  regenerateAsNew: boolean;
  summaryName: string;
  additionalDetails: string;
  formatReferenceSummaryId: string;
}

export type RegenerateModalFormPaths = PathsOf<RegenerateSummaryModalFormShape>;

export const defaultValues: RegenerateSummaryModalFormShape = {
  summaryPromptId: '',
  incorporateAllDocuments: false,
  regenerateAsNew: true,
  summaryName: '',
  additionalDetails: '',
  formatReferenceSummaryId: '',
};
